/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_Edit_TitleInputs */

const en_slot_edit_title = /** @type {(inputs: Slot_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit meal slot`)
};

const de_slot_edit_title = /** @type {(inputs: Slot_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahlzeit bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit meal slot" |
*
* @param {Slot_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_edit_title = /** @type {((inputs?: Slot_Edit_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_Edit_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_edit_title(inputs)
	return en_slot_edit_title(inputs)
});